import React, { useContext, useEffect, useState } from "react";

import estilo from "./styles/ListaUsuarios.module.css";
import supabase from "../supabase/supabaseClient";
import { DataContext } from "../context/DataContext";
import { usePageVisibility } from "react-page-visibility";

function ListaUsuarios() {
  const { usuario, url } = useContext(DataContext);

  const [usuarios, setUsuarios] = useState([]);
  const [cargando, setCargando] = useState(false);

  //controlador
  const isVisible = usePageVisibility();

  React.useEffect(() => {
    if (isVisible) {
      console.log(true);
      actualizarEstado(true);
    } else {
      console.log(false);
      actualizarEstado(false);
    }
  }, [isVisible]);

  async function actualizarEstado(conectado) {
    await supabase
      .from("usuarios_chat")
      .update({ estado: conectado })
      .eq("user_id", usuario.id);
  }

  //traer usuarios
  useEffect(() => {
    const fetchUsuarios = async () => {
      setCargando(false);
      const { data, error } = await supabase.from("usuarios_chat").select();

      if (data) {
        //filtramos usuario principal para no traerlo
        setUsuarios(
          data
            .sort(() => Math.random() - 0.5)
            .filter((e) => e.user_id !== usuario.id)
        );
      }
      setCargando(true);
    };

    fetchUsuarios();
  }, []);

  return (
    <div className={estilo.lista_usuarios}>
      {usuarios && cargando ? (
        <div className={estilo.contenedor}>
          {usuarios.map((e) => (
            <div key={e.id} className={estilo.lista}>
              <div className={estilo.foto}>
                <img
                  src={url + e.user_id}
                  alt={e.nombre_usuario}
                  width="100px"
                  height="100px"
                />
              </div>

              <p>
                {e.nombre_usuario}, {e.edad}
              </p>
            </div>
          ))}
        </div>
      ) : (
        <div className={estilo.cargando}>
          <p>Cargando....</p>
        </div>
      )}
    </div>
  );
}

export default ListaUsuarios;
